import React from 'react';

const Uganda1_university_eng = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_university_eng;
